import { compose, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";

export default (initialState) => {
  initialState =
    JSON.parse(window.localStorage.getItem("state")) || initialState;
  const middleware = [thunk];

  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middleware)
      /* window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__() */
    )
  );

  store.subscribe(() => {
    const state = store.getState();
    const persist = {
      basket: state.basket,
      assortiment: state.assortiment,
      login: state.login,
      deliveryDates: state.deliveryDates,
      currentInformation: state.currentInformation,
      orderHistory: state.orderHistory,
      identify: state.identify
    };
    window.localStorage.setItem("state", JSON.stringify(persist)); //DIT IS NIET ESSENTIEEL, kan ook in memory
  });

  return store;
};
